<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/" color="error" icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">My Courses</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12 sm10>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-tabs v-else class="pa-0 ma-0" v-model="activeTab" color="transparent" slider-color="accent" centered>
        <v-tab ripple>Active</v-tab>
        <v-tab ripple>History</v-tab>
        <v-tab-item>
          <v-layout class="py-3 px-2" row wrap justify-center>
            <v-flex v-if="active.length == 0" class="py-5" xs12>
              <div class="text-xs-center display-3 grey--text text--lighten-1">
                No Active Courses
              </div>
            </v-flex>
            <v-flex v-else v-for="p, i in active" :key="i" class="px-2 pb-3" xs12 md6 lg5>
              <r-progress-card :now="now" :progress="p"></r-progress-card>
            </v-flex>
            <v-flex class="pt-3 text-xs-center" xs12>
              <v-btn to="/register" color="primary" large>Buy Courses</v-btn>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item>
          <v-layout class="py-3 px-2" row wrap justify-center>
            <v-flex v-if="history.length == 0" class="py-5" xs12>
              <div class="text-xs-center display-3 grey--text text--lighten-1">
                None
              </div>
            </v-flex>
            <v-flex v-else v-for="p, i in history" :key="i" class="px-2 pb-3" xs12 md6 lg5>
              <r-progress-card :now="now" :progress="p"></r-progress-card>
            </v-flex>
            <v-flex class="pt-3 text-xs-center" xs12>
              <v-btn to="/register" color="primary" large>Buy Courses</v-btn>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import ProgressCard from './ProgressCard.vue'
export default {
  components: {
    rCrumbs: Crumbs,
    rProgressCard: ProgressCard
  },
  data: () => ({
    loading: false,
    activeTab: null
  }),
  computed: {
    now () {
      return this.$store.getters.now
    },
    active () {
      let active = []
      for (let p of this.$store.getters.progressByStudent(this.$store.getters.user.uid)) {
        if (p.endTime === 0 || this.now < p.endTime) active.push(p)
      }
      return active
    },
    history () {
      let history = []
      for (let p of this.$store.getters.progressByStudent(this.$store.getters.user.uid)) {
        if (p.endTime !== 0 && this.now > p.endTime) history.push(p)
      }
      return history
    },
    getTimeLeft () {
      return (endTime, onlineDays) => {
        if (endTime > 0) {
          if (this.now < endTime) {
            let time = this.$store.getters.time
            let difference = endTime - this.now
            let timeLeftString = ''
            if (difference > time.day) {
              let daysLeft = difference / time.day
              let hrsLeft = (difference % time.day) / time.hour
              timeLeftString = Math.floor(daysLeft)
              timeLeftString += Math.floor(daysLeft) === 1 ? ' day' : ' days'
              timeLeftString += Math.floor(hrsLeft) > 0 ? ' and ' + Math.floor(hrsLeft) : ' left'
              timeLeftString += Math.floor(hrsLeft) === 1 ? ' hour left' : ' hours left'
            } else if (difference > time.hour) {
              let hrsLeft = difference / time.hour
              let minsLeft = (difference % time.hour) / time.minute
              timeLeftString = Math.floor(hrsLeft)
              timeLeftString += Math.floor(hrsLeft) === 1 ? ' hour' : ' hours'
              timeLeftString += Math.floor(minsLeft) > 0 ? ' and ' + Math.floor(minsLeft) : ' left'
              timeLeftString += Math.floor(minsLeft) === 1 ? ' minute left' : ' minutes left'
            } else {
              let minsLeft = difference / time.minute
              let secsLeft = (difference % time.minute) / time.second
              timeLeftString = Math.floor(minsLeft)
              timeLeftString += Math.floor(minsLeft) === 1 ? ' minute' : ' minutes'
              timeLeftString += Math.floor(secsLeft) > 0 ? ' and ' + Math.floor(secsLeft) : ' left'
              timeLeftString += Math.floor(secsLeft) === 1 ? ' second left' : ' seconds left'
            }
            timeLeftString += ' - In progress'
            return timeLeftString
          } else return 'Ended on ' + (new Date(endTime)).toLocaleString()
        } else return onlineDays + ' days left - Not Started'
      }
    }
  },
  methods: {
    goToCourse (progressKey) {
      this.$store.dispatch('setCurrentProgress', {progress: progressKey, section: null, task: null})
      this.$router.push('/my-courses/course-view')
    },
    startCourse (p) {
      let newProgress = {...p}
      newProgress.endTime = this.now + (parseInt(newProgress.onlineDays) * this.$store.getters.time.day)
      this.$store.dispatch('updateProgress', newProgress).then(() => {
        this.goToCourse(p.key)
      })
    },
    completeCourse (p) {
      let newProgress = {...p}
      newProgress.complete = true
      this.$store.dispatch('updateProgress', newProgress)
    },
    isCourseComplete (progressKey) {
      const course = this.$store.getters.courseByKey(this.progress.courseKey)
      let complete = true
      if (course.content) {
        for (let contentKey of course.content) {
          for (let section of this.$store.getters.sectionByContent(contentKey)) {
            if (!this.isSectionComplete(section.key)) complete = false
          }
        }
      } else complete = false
      return complete
    },
    isSectionComplete (sectionKey) {
      let tasks = this.$store.getters.taskBySection(sectionKey)
      let taskProgress = null
      let complete = false
      if (tasks.length > 0) {
        for (let t of tasks) {
          taskProgress = this.$store.getters.taskProgressByTaskByProgress(t.key, this.currentProgress.progress)
          complete = taskProgress ? taskProgress.complete : false
          if (taskProgress) complete = taskProgress.endTime ? (this.now > taskProgress.endTime) : complete
        }
      } else complete = true
      return complete
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myCourses/MyCoursesList.vue